// src/services/fiscal/TransporteFiscalService.js
import { deleteData, fetchData, postData, putData } from '../Api';

const endpoint = (tipo, id) => `/TransporteFiscal/${tipo}${id ? `/${id}` : ''}`;
export const listarCadastrosFiscais = (tipo, filialId) => fetchData(endpoint(tipo), { filialId });
export const obterCadastroFiscal = (tipo, id) => fetchData(endpoint(tipo, id));
export const salvarCadastroFiscal = (tipo, item) => (
  item.id ? putData(endpoint(tipo, item.id), item) : postData(endpoint(tipo), item)
);
export const inativarCadastroFiscal = (tipo, id) => deleteData(endpoint(tipo, id));
